import { render, staticRenderFns } from "./ApprovalView.vue?vue&type=template&id=39bb1036&scoped=true&"
import script from "./ApprovalView.vue?vue&type=script&lang=js&"
export * from "./ApprovalView.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalView.vue?vue&type=style&index=0&id=39bb1036&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bb1036",
  null
  
)

export default component.exports